// Bella Vita frontend — toast host + toast() service.
// Behaviour + markup copied from design-v2/js/preview.js `toast()`.
// Styling: .bv-toast-wrap / .bv-toast / @keyframes bv-toast-in in the
// design-v2 components.css (brought over unchanged).

import { el } from '../lib/dom.js';

const HOST_ID = 'bv-toasts';

/** Idempotently ensure the toast container exists on <body>. Call once at boot. */
export function mountToastHost() {
  let host = document.getElementById(HOST_ID);
  if (!host) {
    host = el(`<div class="bv-toast-wrap" id="${HOST_ID}" role="status" aria-live="polite"></div>`);
    document.body.appendChild(host);
  }
  return host;
}

/**
 * Show a transient toast. Same timing as the prototype (visible ~2.4s, then
 * a 250ms fade-out before removal).
 * @param {string} msg  plain text
 */
export function toast(msg) {
  const host = mountToastHost();
  const node = el('<div class="bv-toast"></div>');
  node.textContent = String(msg);
  host.appendChild(node);
  window.setTimeout(() => {
    node.style.opacity = '0';
    window.setTimeout(() => node.remove(), 250);
  }, 2400);
  return node;
}
